import React, { useState, ReactNode } from 'react';
import { Layout, Menu, Breadcrumb, theme, ConfigProvider } from 'antd';
import type { MenuProps } from 'antd';
import {
    UserOutlined,
    LaptopOutlined,
    NotificationOutlined,
} from '@ant-design/icons';
import { Book, Package, ListNumbers, ArrowsLeftRightIcon, ChartLineUpIcon, FileTextIcon, KeyIcon, ShieldCheckIcon, SquaresFourIcon, UserPlusIcon, UsersIcon, WalletIcon, ClipboardTextIcon, ConfettiIcon, QuestionMarkIcon } from '@phosphor-icons/react';
import MenuIcons from 'components/Icon/Menu';
import UserManagementIcon from 'components/Icon/UserManagement';
import Wallet from 'components/Icon/Wallet';
import ActiveAccountHeader from './AccountHeader';
import { useTheme, dark, light, ThemeSwitch } from 'components/provider/theme';

const { Header, Content, Footer, Sider } = Layout;

const commonItemMenuStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '16px',
    fontWeight: '700',
    height: '48px',
    padding: '0 16px',
}

const items: MenuProps['items'] = [
    {
        key: '1',
        icon: <SquaresFourIcon size={24} />,
        label: 'DashBoard',
        onClick: () => window.location.href = '/',
        style: commonItemMenuStyle,
    },
    {
        key: '2',
        icon: <UsersIcon size={24} />,
        label: 'User Management',
        onClick: () => window.location.href = '/users',
        style: commonItemMenuStyle,
    },
    {
        key: '3',
        icon: <WalletIcon size={24} />,
        label: 'Trading Accounts',
        onClick: () => window.location.href = '/accounts',
        style: commonItemMenuStyle,
    },
    {
        key: '4',
        icon: <ArrowsLeftRightIcon size={24} />,
        label: 'Transactions',
        onClick: () => window.location.href = '/transactions',
        style: commonItemMenuStyle,
    },
    {
        key: '5',
        icon: <KeyIcon size={24} />,
        label: 'Roles ',
        onClick: () => window.location.href = '/role',
        style: commonItemMenuStyle,
    },
    {
        key: '6',
        icon: <KeyIcon size={24} />,
        label: 'Permissions ',
        onClick: () => window.location.href = '/permissions',
        style: commonItemMenuStyle,
    },
    // {
    //     key: '7',
    //     icon: <ShieldCheckIcon size={24} />,
    //     label: 'Risk Management',
    //     onClick: () => window.location.href = '/risk-management',
    //     style: commonItemMenuStyle,
    // },
    // {
    //     key: '8',
    //     icon: <FileTextIcon size={24} />,
    //     label: 'Reports',
    //     onClick: () => window.location.href = '/reports',
    //     style: commonItemMenuStyle,
    // },
    {
        key: '9',
        icon: <ConfettiIcon size={24} />,
        label: 'Events',
        onClick: () => window.location.href = '/events',
        style: commonItemMenuStyle,
    },
    // {
    //     key: '10',
    //     icon: <UserPlusIcon size={24} />,
    //     label: 'Collaborators',
    //     onClick: () => window.location.href = '/collaborators',
    //     style: commonItemMenuStyle,
    // },
    // {
    //     key: '11',
    //     icon: <Book size={24} />,
    //     label: 'Daily ',
    //     onClick: () => window.location.href = '/daily',
    //     style: commonItemMenuStyle,
    // },
    {
        key: '12',
        icon: <ListNumbers size={24} />,
        label: 'Numerology ',
        onClick: () => window.location.href = '/numerology',
        style: commonItemMenuStyle,
    },
    {
        key: '13',
        icon: <Package size={24} />,
        label: 'Product ',
        onClick: () => window.location.href = '/product',
        style: commonItemMenuStyle,
    },
    {
        key: '14',
        icon: <Package size={24} />,
        label: 'Stores ',
        onClick: () => window.location.href = '/stores',
        style: commonItemMenuStyle,
    },
    {
        key: '15',
        icon: <ClipboardTextIcon size={24} />,
        label: 'Subscriptions ',
        onClick: () => window.location.href = '/subscriptions',
        style: commonItemMenuStyle,
    },
    {
        key: '16',
        icon: <Package size={24} />,
        label: 'Point ',
        onClick: () => window.location.href = '/point',
        style: commonItemMenuStyle,
    },
    {
        key: '17',
        icon: <Package size={24} />,
        label: 'Bots ',
        onClick: () => window.location.href = '/bots',
        style: commonItemMenuStyle,
    },
    {
        key: '18',
        icon: <Package size={24} />,
        label: 'Recomendation',
        onClick: () => window.location.href = '/recomendation',
        style: commonItemMenuStyle,
    },
    // {
    //     key: '19',
    //     icon: <Package size={24} />,
    //     label: 'Coach Daily',
    //     onClick: () => window.location.href = '/coach-daily',
    //     style: commonItemMenuStyle,
    // },
    // {
    //     key: '12',
    //     icon: <Package size={24} />,
    //     label: 'Product Section ',
    //     onClick: () => window.location.href = '/product-section',
    //     style: commonItemMenuStyle,
    // },
    // {
    //     key: '13',
    //     icon: <Package size={24} />,
    //     label: 'Product introduction ',
    //     onClick: () => window.location.href = '/product-introduction',
    //     style: commonItemMenuStyle,
    // }
    {
        key: '20',
        icon: <QuestionMarkIcon />,
        label: 'Help',
        onClick: () => window.location.href = '/help',
        style: commonItemMenuStyle,
    }
];

const siderStyle: React.CSSProperties = {
    overflow: 'auto',
    height: '100vh',
    position: 'sticky',
    insetInlineStart: 0,
    top: 0,
    bottom: 0,
    scrollbarWidth: 'none',
    scrollbarGutter: 'unset',
};

const keyPathList = [
    { key: '1', path: '/' },
    { key: '2', path: '/users' },
    { key: '3', path: '/accounts' },
    { key: '4', path: '/transactions' },
    { key: '5', path: '/role' },
    { key: '6', path: '/permissions' },
    { key: '7', path: '/risk-management' },
    { key: '8', path: '/reports' },
    { key: '9', path: '/events' },
    { key: '10', path: '/collaborators' },
    { key: '11', path: '/daily' },
    { key: '12', path: '/numerology' },
    { key: '13', path: '/product' },
    { key: '14', path: '/stores' },
    { key: '15', path: '/subscriptions' },
    { key: '16', path: '/point' },
    { key: '17', path: '/bots' },
    { key: '18', path: '/recomendation' },
    { key: '19', path: '/coach-daily' },
    { key: '20', path: '/help' },

    // { key: '12', path: '/product-section' },
    // { key: '13', path: '/product-introduction' },
]

interface SidebarLayoutProps {
    children: ReactNode;
    title?: ReactNode;
}

const SidebarLayout: React.FC<SidebarLayoutProps> = ({ children, title }) => {
    const [collapsed, setCollapsed] = useState(false);
    const [currentPath, setCurrentPath] = useState(window.location.pathname);
    const { theme, toggleTheme } = useTheme();
    React.useEffect(() => {
        const handlePathChange = () => {
            const currentPath = window.location.pathname;
            setCurrentPath(currentPath);
            const currentItem = keyPathList.find(item => item.path === currentPath);
            if (currentItem) {
                document.querySelector(`.ant-menu-item-selected`)?.classList.remove('ant-menu-item-selected');
                document.querySelector(`.ant-menu-item-${currentItem.key}`)?.classList.add('ant-menu-item-selected');
            }
        };

        window.addEventListener('popstate', handlePathChange);
        return () => window.removeEventListener('popstate', handlePathChange);
    }, []);



    return (
        <ConfigProvider
            theme={{
                token: {
                    // Seed Token
                    borderRadius: 6,
                    colorBgBase: '#fff',
                    colorError: '#ff4d4f',
                    colorInfo: '#1677ff',
                    colorLink: '#1677ff',
                    colorPrimary: '#1677ff',
                    colorSuccess: '#52c41a',
                    colorTextBase: '#000',
                    colorWarning: '#faad14',
                    controlHeight: 32,
                    fontSize: 14,
                    lineType: 'solid',
                    lineWidth: 1,
                    motion: true,
                    motionBase: 0,
                    motionUnit: 0.1,
                    opacityImage: 1,
                    sizePopupArrow: 16,
                    sizeStep: 4,
                    sizeUnit: 4,
                    wireframe: false,
                    zIndexBase: 0,
                    zIndexPopupBase: 2000,
                    // Map token

                    borderRadiusLG: 8,
                    borderRadiusOuter: 4,
                    borderRadiusSM: 4,
                    borderRadiusXS: 2,
                    colorBgBlur: 'transparent',
                    colorBgContainer: '#ffffff',
                    colorBgElevated: '#ffffff',
                    colorBgLayout: '#f5f5f5',
                    colorBgMask: 'rgba(0,0,0,0.45)',
                    colorBgSolid: 'rgb(0,0,0)',
                    colorBgSolidActive: 'rgba(0,0,0,0.95)',
                    colorBgSolidHover: 'rgba(0,0,0,0.75)',
                    colorBgSpotlight: 'rgba(0,0,0,0.85)',
                    colorBorder: '#d9d9d9',
                    colorBorderSecondary: '#f0f0f0',
                    colorErrorActive: '#d9363e',
                    colorErrorBg: '#fff2f0',
                    colorErrorBgActive: '#ffccc7',
                    colorErrorBgFilledHover: '#ffdfdc',
                    colorErrorBgHover: '#fff1f0',
                    colorErrorBorder: '#ffccc7',
                    colorErrorBorderHover: '#ffa39e',
                    colorErrorHover: '#ff7875',
                    colorErrorText: '#ff4d4f',
                    colorErrorTextActive: '#d9363e',
                    colorErrorTextHover: '#ff7875',
                    colorFill: 'rgba(0,0,0,0.15)',
                    colorFillQuaternary: 'rgba(0,0,0,0.02)',
                    colorFillSecondary: 'rgba(0,0,0,0.06)',
                    colorFillTertiary: 'rgba(0,0,0,0.04)',
                    colorInfoActive: '#0958d9',
                    colorInfoBg: '#e6f4ff',
                    colorInfoBgHover: '#bae0ff',
                    colorInfoBorder: '#91caff',
                    colorInfoBorderHover: '#69b1ff',
                    colorInfoHover: '#69b1ff',
                    colorInfoText: '#1677ff',
                    colorInfoTextActive: '#0958d9',
                    colorInfoTextHover: '#4096ff',
                    colorLinkActive: '#0958d9',
                    colorLinkHover: '#69b1ff',
                    colorPrimaryActive: '#0958d9',
                    colorPrimaryBg: '#e6f4ff',
                    colorPrimaryBgHover: '#bae0ff',
                    colorPrimaryBorder: '#91caff',
                    colorPrimaryBorderHover: '#69b1ff',
                    colorPrimaryHover: '#4096ff',
                    colorPrimaryText: '#1677ff',
                    colorPrimaryTextActive: '#0958d9',
                    colorPrimaryTextHover: '#4096ff',
                    colorSuccessActive: '#389e0d',
                    colorSuccessBg: '#f6ffed',
                    colorSuccessBgHover: '#d9f7be',
                    colorSuccessBorder: '#b7eb8f',
                    colorSuccessBorderHover: '#95de64',
                    colorSuccessHover: '#95de64',
                    colorSuccessText: '#52c41a',
                    colorSuccessTextActive: '#389e0d',
                    colorSuccessTextHover: '#73d13d',
                    colorText: 'rgba(0,0,0,0.88)',
                    colorTextQuaternary: 'rgba(0,0,0,0.25)',
                    colorTextSecondary: 'rgba(0,0,0,0.65)',
                    colorTextTertiary: 'rgba(0,0,0,0.45)',
                    colorWarningActive: '#d48806',
                    colorWarningBg: '#fffbe6',
                    colorWarningBgHover: '#fff1b8',
                    colorWarningBorder: '#ffe58f',
                    colorWarningBorderHover: '#ffd666',
                    colorWarningHover: '#ffd666',
                    colorWarningText: '#faad14',
                    colorWarningTextActive: '#d48806',
                    colorWarningTextHover: '#ffc53d',
                    colorWhite: '#fff',
                    controlHeightLG: 40,
                    controlHeightSM: 24,
                    controlHeightXS: 16,
                    fontSizeHeading1: 38,
                    fontSizeHeading2: 30,
                    fontSizeHeading3: 24,
                    fontSizeHeading4: 20,
                    fontSizeHeading5: 16,
                    fontSizeLG: 16,
                    fontSizeSM: 12,
                    fontSizeXL: 20,
                    lineHeight: 1.5714285714285714,
                    lineHeightHeading1: 1.2105263157894737,
                    lineHeightHeading2: 1.2666666666666666,
                    lineHeightHeading3: 1.3333333333333333,
                    lineHeightHeading4: 1.4,
                    lineHeightHeading5: 1.5,
                    lineHeightLG: 1.5,
                    lineHeightSM: 1.6666666666666667,
                    lineWidthBold: 2,
                    motionDurationFast: '0.1s',
                    motionDurationMid: '0.2s',
                    motionDurationSlow: '0.3s',
                    size: 16,
                    sizeLG: 24,
                    sizeMD: 20,
                    sizeMS: 16,
                    sizeSM: 12,
                    sizeXL: 32,
                    sizeXS: 8,
                    sizeXXL: 48,
                    sizeXXS: 4
                },
                components: {
                    Menu: {
                        activeBarBorderWidth: 0,
                        groupTitleColor: 'rgba(0,0,0,0.65)',
                        itemColor: theme === 'dark' ? '#fff' : 'rgba(0,0,0,0.65)',
                        itemHoverColor: theme === 'dark' ? '#fff' : 'rgba(0,0,0,0.85)',
                        itemHoverBg: theme === 'dark' ? '#374151' : 'rgba(0,0,0,0.06)',
                        itemActiveBg: theme === 'dark' ? '#2563eb' : '#e6f4ff',
                        colorBgContainer: theme === 'dark' ? '' : '#fff',
                        itemSelectedBg: theme === 'dark' ? '#2563eb' : '#e6f4ff',
                        itemSelectedColor: theme === 'dark' ? '#fff' : '#1677ff'
                    },

                    Layout: {
                        headerHeight: 64,
                        headerBg: theme === 'dark' ? dark.backgroundBaseSecondary : light.backgroundBaseSecondary,
                        siderBg: theme === 'dark' ? dark.backgroundBaseSecondary : light.backgroundBaseSecondary,
                        triggerBg: theme === 'dark' ? '#374151' : dark.backgroundBase,
                        bodyBg: theme === 'dark' ? dark.backgroundNone : light.backgroundNone,
                        footerBg: theme === 'dark' ? 'oklch(27.8% 0.033 256.848)' : light.backgroundBaseSecondary,
                        colorText: theme === 'dark' ? dark.textPrimary : light.textPrimary,
                    },

                    Input: {
                        addonBg: theme === 'dark' ? '#374151' : '',
                        colorBgContainer: theme === 'dark' ? '#374151' : '',
                        colorBorder: theme === 'dark' ? 'gray' : '',
                        colorText: theme === 'dark' ? '#fff' : '',
                        hoverBorderColor: '',
                        activeBorderColor: '',
                        colorTextPlaceholder: theme === 'dark' ? 'white' : '',
                    },

                    Pagination: {
                        colorText: theme === 'dark' ? '#fff' : '',
                        colorBgContainer: theme === 'dark' ? 'blue-600' : '',
                        colorBgTextHover: theme === 'dark' ? '#374151' : '',
                        colorTextDisabled: theme === 'dark' ? 'gray' : ''
                    },

                    Select: {
                        colorTextPlaceholder: theme === 'dark' ? '#fff' : 'rgba(0,0,0,0.25)',
                        colorText: theme === 'dark' ? '#fff' : 'rgba(0,0,0,0.88)',
                        colorTextQuaternary: theme === 'dark' ? '#fff' : 'rgba(0,0,0,0.25)',
                        colorBgContainer: theme === 'dark' ? '#1e2939' : '#ffffff',
                        colorBgElevated: theme === 'dark' ? '#374151' : '#ffffff',
                        colorBgTextHover: theme === 'dark' ? '#374151' : '',
                        fontSizeLG: 14,
                    },

                    DatePicker: {
                        colorTextPlaceholder: theme === 'dark' ? '#fff' : '',
                        colorText: theme === 'dark' ? '#fff' : '',
                        colorTextDisabled: theme === 'dark' ? '#155ddd' : '',
                        colorTextTertiary: theme === 'dark' ? '#fff' : '',
                        colorIcon: theme === 'dark' ? '#fff' : '',
                        colorTextQuaternary: theme === 'dark' ? '#fff' : '',
                        colorBgContainer: theme === 'dark' ? '#1e2939' : '#ffffff',
                        colorBgElevated: theme === 'dark' ? '#374151' : '#ffffff',
                        multipleItemColorDisabled: theme === 'dark' ? '#fff' : '',
                    },
                    Breadcrumb: {
                        itemColor: theme === 'dark' ? dark.textPrimary : light.textPrimary,
                        separatorColor: theme === 'dark' ? dark.textSecondary : light.textSecondary,
                        lastItemColor: theme === 'dark' ? dark.textblur : light.textblur,
                    },
                    Modal: {
                        contentBg: theme === 'dark' ? dark.backgroundBaseSecondary : light.backgroundBaseSecondary,
                        headerBg: theme === 'dark' ? dark.backgroundBaseSecondary : light.backgroundBaseSecondary,
                        colorText: theme === 'dark' ? dark.textPrimary : light.textPrimary,
                        titleColor: theme === 'dark' ? dark.textPrimary : light.textPrimary,
                    },
                    Table: {
                        borderColor: theme === 'dark' ? dark.borderColor : light.borderColor,
                        headerBorderRadius: 0,
                        headerBg: theme === 'dark' ? '#111827' : '#fff',
                        headerSortHoverBg: theme === 'dark' ? '#374151' : '#f0f0f0',
                        headerColor: theme === 'dark' ? dark.textPrimary : light.textPrimary,
                        colorBgContainer: theme === 'dark' ? '#0e192b' : '#ffffff',
                        colorIcon: theme === 'dark' ? '#fff' : '',
                        colorText: theme === 'dark' ? dark.textPrimary : light.textPrimary,
                        rowHoverBg: theme === 'dark' ? '#374151' : '#f0f0f0',
                        rowSelectedBg: theme === 'dark' ? '#1e50bd' : '#88caff',
                        rowSelectedHoverBg: theme === 'dark' ? '#3363cb' : '#e6f4ff',

                    },
                    Empty: {
                        colorTextDescription: theme === 'dark' ? dark.textSecondary : light.textSecondary,
                    },
                    Divider: {
                        colorSplit: theme === 'dark' ? '#ffffff' : '#00000066',
                        colorText: theme === 'dark' ? dark.textSecondary : light.textSecondary,
                    }


                },
            }}
        >
            <Layout style={{ minHeight: '100vh' }}>

                <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed} style={siderStyle} width={240}>
                    <div
                        style={{
                            borderBottom: '1px solid #e8e8e8',
                            borderColor: theme === 'dark' ? dark.borderColor : light.borderColor,
                            color: theme === 'dark' ? '#fff' : ''
                        }}
                        className="w-full h-16 flex items-center justify-center font-bold text-xl">
                        {collapsed ?
                            (
                                <ChartLineUpIcon size={32} />
                            )
                            : 'BeqHolding'}
                    </div>
                    <Menu
                        defaultSelectedKeys={['1']}
                        mode="inline"
                        items={items}
                        style={{
                            paddingLeft: '4px',
                            paddingRight: '4px',
                        }}
                        selectedKeys={[keyPathList.find(item => item.path === currentPath)?.key || '1']}
                    />
                </Sider>
                <Layout>
                    <Header
                        style={{ padding: 0, borderBottom: '1px solid #e8e8e8', borderColor: theme === 'dark' ? dark.borderColor : light.borderColor }}>
                        <div className={`${theme === 'dark' ? dark.textPrimary : light.textPrimary} w-full h-full flex items-center justify-between px-4`}>
                            {title && (
                                <div style={{
                                    color: theme === 'dark' ? dark.textPrimary : light.textPrimary,
                                    paddingLeft: 24, fontSize: 20, fontWeight: 500
                                }}>
                                    {title}
                                </div>
                            )}
                            <div className="flex items-center gap-4">
                                <ActiveAccountHeader />
                            </div>
                        </div>
                    </Header>
                    <Content style={{ margin: '0 16px' }}>
                        <Breadcrumb
                            style={{ margin: '16px 0' }}
                            items={window.location.href.replace(window.location.host, '')
                                .split('?')[0]
                                .split('/')
                                .filter(Boolean)
                                .map((segment, idx, arr) => ({
                                    title: idx === 0 ? 'Home' : segment.charAt(0).toUpperCase() + segment.slice(1),
                                    path: '/' + arr.slice(0, idx + 1).join('/'),
                                }))
                                .map(({ title, path }) => ({ title }))}
                        />
                        <div
                            style={{
                                padding: 24,
                                minHeight: 360,
                            }}
                        >
                            {children}
                        </div>
                    </Content>
                    <Footer style={{ textAlign: 'start', height: '48px', lineHeight: '48px', padding: '0 24px' }}>
                        BeqHolding {new Date().getFullYear()} © Created by BeqHolding Team
                    </Footer>
                </Layout>
            </Layout>
        </ConfigProvider>
    );
};

export default SidebarLayout;